<template>
    <div class="deal_index_box">
        <!-- 結算管理 -->
        <div class="deal_title">
            <div>提領管理<span>》</span>已結算查詢</div>
            <div class="deal_hr">
                <div class="cut_off"></div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="deal_content_box" v-show="detailsTF" v-loading="inquireTF">
            <div class="deal_content_title">已結算查詢</div>
            <div class="deal_content">
                <div class="center_box">
                    <!-- 已結算查詢 -->
                    <!-- <div class="time_box">每天上午10：00前完成資料更新，目前資料更新至<span>{{time}}</span></div> -->
                    <el-form ref="form" :model="form" label-width="90px">
                        <el-form-item label="申請時間：">
                            <el-date-picker
                                v-model="dateValue"
                                type="daterange"
                                align="center" 
                                unlink-panels
								value-format="timestamp"
                                range-separator="至"
                                start-placeholder="開始日期"
                                end-placeholder="結束日期"
                                :picker-options="pickerOptions">
                            </el-date-picker>
                            <span class="deal_content_span">查詢期日不可超過31天</span>
                        </el-form-item>
                        <el-form-item label="申請人：" v-if="this.$store.state.uid==1">
                            <el-input class="money_input money_input01" placeholder="" v-model="uidVal" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="退款金額：" class="money_box" v-show="false">
                            <el-input class="money_input" placeholder="" v-model="money1" clearable></el-input>
                        <span>至</span><el-input class="money_input" placeholder="" v-model="money2" clearable></el-input>
                        </el-form-item>
						<el-form-item label="提領方式：  ">
						    <el-select v-model="paymentValue" placeholder="所有提領方式">
						    <el-option
						    v-for="item in type2"
						    :key="item.value"
						    :label="item.label"
						    :value="item.value">
						    </el-option>
						    </el-select>
						</el-form-item>
                    </el-form>
                    <!-- 查詢按钮 -->
                    <div class="inquire_button">
                    <el-button type="primary" @click="inquireFun()">查詢</el-button> 
                    </div>
                    <!-- 表单 -->
                    <div class="table_download">
                        <el-button plain class="table_download_button" @click="goLoginbu()">查看結算費率、週期</el-button>
                        <span>匯出結算表</span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt="" @click="ExcelFun('exportexcel')"></span>
                        <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt="" @click="ExcelFun('exporttxt')"></span>
                    </div>
                    <div>
                         <!-- 表单头 -->
                            <div class="table_header">
                                <div class="table_date">結算日期</div>
                                <div class="table_money">支付結算金額</div>
                                <div class="table_money">退款結算金額</div>
                                <div class="table_charge">手續費</div>
                                <div class="table_draw">提領金額</div>
                                <div class="table_name">提領申請人</div>
								<div class="table_type">提領方式</div>
                                <div class="table_status">提現狀態</div>
                                <div class="table_operation">操作</div>
                            </div>
                            <!-- 表单内容 -->
							<div class="table_maxbox" v-for="(list, index) of pagelist" :key="index" v-show="currentPage == (index+1)">
								<div class="table_content" v-for="item of list" :key="item.id">
								    <div class="table_date">{{item.starttime}}</div>
								     <div class="table_money">{{item.pay_money}}</div>
								    <div class="table_money">{{item.refund}}</div>
								    <div class="table_charge">{{item.commission}}</div>
								    <div class="table_draw">{{item.withdraw}}</div>
								    <div class="table_name">{{item.principal}}</div>
									<div class="table_type">{{item.type}}</div>
								    <div class="table_status">{{item.status}}</div>
								    
								    <div class="table_operation">
								        <span  @click="detailsFun(item.uid,item.time)">
								            <span >查看</span><i class="el-icon-view"></i>
								        </span>
<!-- 								        <span>
								            <span>下載帳單</span><i class="el-icon-document"></i>
								        </span> -->
								    </div>
								</div>
							</div>
                            
                        <!-- 表单分页列表 -->
                        <div class="table_pagination">
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-sizes="[10, 30, 50]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="totalNumber"
                                >
                            </el-pagination>
                        </div>
                        <!-- 注： -->
     <!--                   <div class="annotation">
                            <p class="annotation_p">注：</p>
                            <p class="annotation_p">1、支付結算金額-退款結算金額-手續費=提領金額</p>
                            <p>如果開通了手續費帳戶，支付結算金額-退款結算金額=提領金額</p>
                            <p>如果開通了退款支出分離，支付結算金額-手續費=提領金額</p>
                            <p>如果開通了手續費帳戶和退款支出分離，支付結算金額=提領金額</p>
                            <p class="annotation_p">2、提領金額僅作為結算統計參考，實際收到的款項請以提領記錄為準備</p>
                            <p>若遇到結算問題，<span class="annotation_span">點擊此處查看說明</span>。</p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
		<settlement-details v-show="!detailsTF" @detailsFun="detailsFun()"></settlement-details>
        <!-- deal_index_box -->
    </div>
</template> 

<script>
import axios from 'axios';
import SettlementDetails from '../../common/SettlementDetails.vue';

// import { type } from 'os';
export default {
	
    name: 'LoginDealSettlement',
    data() {
        return {
			// 查询时候加载状态
			inquireTF: false,
			// 訂單詳情切換
			detailsTF: true,
			// 类型
			 type2: [ {
			    value: '1',
			    label: '自動提領'
			}, {
			    value: '2',
			    label: '人工提領'
			}, {
			    value: '0',
			    label: '所有提領方式'
			}
			],
            form:{
            },
            // 日期
            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
            time:'2019-03-29',
            dateValue: '',
            paymentValue: '0',
            transactionValue: '',
            uidVal: '',
            money1: '',
            money2: '',
            // 表单
            tableData: [{
                id: "001",
                date: '2019-03-14',
                status: '提現成功',
                money: '350.00',
                charge: '11.26',
                drawMoney: '338.74',
                name: '15646131(陳玲玲)'
            }, {
                id: "002",
                date: '2019-03-14',
                status: '提現中',
                money: '200.00',
                charge: '11.26',
                drawMoney: '188.74',
                name: '15646131(陳玲玲)'
            }, {
                id: "003",
                date: '2019-03-14',
                status: '提現失敗',
                money: '99.00',
                charge: '11.26',
                drawMoney: '87.74',
                name: '15646131(陳玲玲)'
            }, {
                id: "004",
                date: '2019-03-14',
                status: '提現中',
                money: '417.00',
                charge: '11.26',
                drawMoney: '405.74',
                name: '15646131(陳玲玲)'
            }],
            totalNumber: 46,
		
			// 表单
			tableData:[],
			totalNumber: 0,
			currentPage: 1,
			pageSize: 10,
			pagelist:[],
			// 时间
			start_time: '',
			end_time: '',
			paystart_time: '',
			payend_time: '',
        // return
        }
    },
	components: {
	    SettlementDetails
	},
    methods: {
        handleClick(tab, event) {
            // console.log(tab, event);
        },
       handleSizeChange(val) {
        // console.log(`每页 ${val} 条`);
        this.pageSize = val;
        this.pagelist = this.pagesFun(val);
        },
        handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.currentPage = val;
        },
		// 查看手续费
		goLoginbu(){
			this.$router.push('/login/account/loginbu');
		},
		// FUN-分頁顯示
		pagesFun(number){
		    let pages=[];
		    this.tableData.forEach((item,index)=>{
		        var page=Math.floor(index/number);
		        if(!pages[page]){
		            pages[page]=[];
		        }
		        pages[page].push(item);
		    })
		    return pages;
		},
		 // FUN-訂單詳情
		detailsFun(id,time){
			this.detailsTF = !this.detailsTF;
			axios.get(this.$store.state.axiosqueryUrl, {
			    params: {
					type: this.paymentValue,
					start_time: this.start_time,
					end_time: this.end_time,
					keyword: this.uidVal,
					uid: this.$store.state.uid,
			        xq_uid: id,
			        time: time,
					do : 'details',

			    }
			}).then((res) => {
			    // console.log(res.data.message);
			    this.$store.commit('changeDetails',res.data.message);
			})
	

		},
		// FUN-EXCEL下載
		ExcelFun(hxr){
		    let txt_url = '';
		    let charset = '';
		    let uidvalue = '';
		    // 简体还是繁体
		    if (navigator.language === "zh-TW"){
		        charset = "BIG5";
		    } else {
		        charset = "GBK";
		    }
		    // 是否UID
		    // if (this.uidVal == ''){
		    //    uidvalue = this.$store.state.uid;
		    // } else {
		    //    uidvalue = this.uidVal;
		    // }
		    // 下载：
		    txt_url = this.$store.state.axiosqueryUrl
		        +'&keyword='+this.uidVal
		        +'&uid='+this.$store.state.uid
		        +'&end_time='+this.end_time
		        +'&start_time='+this.start_time
		        +'&type='+this.paymentValue
		        +'&charset='+charset
		        +'&do='+hxr;
		
		    window.location.href = txt_url;
		},
		// 请求列表
	    inquireFun(){
			// 交易时间：
			if( this.dateValue ){
			    this.end_time = this.dateValue[1].toString();
			    this.end_time = this.end_time.substring(0, 10);
			    this.start_time = this.dateValue[0].toString();
			    this.start_time = this.start_time.substring(0, 10);
			    
			} else {
			    this.dateValue = '';
			    this.end_time = '';
			    this.start_time = '';
			}
			this.inquireTF = true;
	        axios.get(this.$store.state.axiosqueryUrl, {
	          params: {
				  type: this.paymentValue,
				  start_time: this.start_time,
				  end_time: this.end_time,
	              keyword: this.uidVal,
				  uid:this.$store.state.uid,
				  
	          }
	      }).then((res) => {
			  
	          this.inquireTF = false;
	          this.currentPage = 1;
	           if(res.data.message){
	              if(res.data.status){
	                  this.tableData = res.data.message;
	                  // console.log(this.tableData);
	                  this.totalNumber = res.data.message.length;
	                  this.pagelist = this.pagesFun(this.pageSize);
	              } else {
	                  this.$message({
	                      showClose: true,
	                      message: res.data.message,
	                      type: 'error',
	                      duration: 1000
	                  });
	              }
	           } else {
	              this.$message({
	                  showClose: true,
	                  message: '沒有數據',
	                  type: 'error',
	                  duration: 1000
	              });
	              this.tableData = [];
	              this.pagelist = this.pagesFun(this.pageSize);
	              this.totalNumber = 0;
	          }
	      })
	  
	    },
    },
	 created(){
		 // 時間：
		 let start = new Date(new Date(new Date().toLocaleDateString()).getTime());
		 start.setTime(start.getTime() - 3600 * 1000 * 24*7);
		 start = start.getTime();
		 let end = new Date(new Date(new Date().toLocaleDateString()).getTime());
		 end = end.getTime();
		 let list = [];
		 list[0] = start;
		 list[1] = end;
		 this.dateValue = list;
		 this.inquireFun();
	 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 交易管理》交易订单 */
    .deal_index_box {
        margin: 20px;
        font-size: 15px;
        color: black;
    }
    .deal_title {
        display: flex;
        justify-content: flex-start;
        margin: 30px 0;
    }
    .deal_title span {
        margin-left: 15px;
        margin-right: 8px;
    }
    .deal_title .deal_hr {
        flex: 1;
        margin-left: 18px;
    }
    .deal_title .deal_hr .cut_off {
        height: 3px;
        background: black;
        margin-top: 8px;
    }
/* 内容 */
    .time_box {
        font-size: 17px;
        margin-bottom: 33px;
        letter-spacing: 1px;
    }
    .time_box > span {
        color: #e73262;
        margin: 0 5px;
    }
    .datetime_box > span {
        margin: 10px;
    }
    .deal_content_box {
        font-size: 13px;
        margin-top: 20px;
    }
    .deal_content_title {
        height: 42px;
        background: #666666;
        line-height: 42px;
        color: white;
        padding-left: 14px;
    }
    .deal_content {
        box-sizing: border-box;
        /* height: 53.6vw; */
        min-height: 500px;
        border: 1px solid #666666;
        background: #ffffff;
        padding: 38px 20px;
        padding-top: 26px;
    }
    .center_box {
        min-width: 900px;
        margin: 10px 65px;
    }
    .deal_content_span {
        margin-left: 23px;
        font-size: 11px;
        color: #e73262;
    }
    .deal_content_tab_first {
    }
    .deal_content_tab_first > div {
        margin: 14px 0;
    }
    .money_box span {
        margin: 0 10px;
    }
    .money_input {
        width: 140px;
        /* margin-left: 4px; */
    }
    .money_input01 {
        margin-left: 4px;
    }
    .inquire_button {
        padding: 10px;
    }
    /* 表单 */
    .table_download {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 6px 0;
    }
    .table_download_button {
        padding: 6px 10px;
    }
    .table_download span {
        display: inline-block;
        margin: 0 10px;
    }
    /* 表单头 */
    .table_header {
        height: 36px;
        line-height: 36px;
        background: #f2f2f2;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        text-align: center;
    }
    .table_maxbox >div+div {
        border-top: 1px solid #e7e7e7;
    }
    .table_content {
        padding: 10px 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        text-align: center;
    }
     .table_date {
        box-sizing: border-box;
        width: 12%;
        padding-left: 14px;
        padding-right: 10px;
    }
    .table_merchantorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 23%;
        padding: 0 10px;
        min-width: 160px;
    }
    .table_paymentorder {
        box-sizing: border-box;
        word-break: break-all;
        word-wrap: break-word;
        width: 23%;
        min-width: 160px;
        padding: 0 10px;
        min-width: 160px;
    }
    .table_paymenttype {
        box-sizing: border-box;
        width: 12%;
        padding: 0 10px;
        min-width: 77px;
    }
    .table_status {
        box-sizing: border-box;
        width: 12%;
        padding: 0 10px;
    }
    .table_money {
        box-sizing: border-box;
        width: 12%;
        padding: 0 10px;
    }
    .table_charge {
        box-sizing: border-box;
        width: 7%;
        padding: 0 10px;  
    }
    .table_draw {
        box-sizing: border-box;
        width: 10%;
        padding: 0 10px;
    }
    .table_name {
        box-sizing: border-box;
        width: 12%;
        padding: 0 10px;
    }
	.table_type{
		box-sizing: border-box;
		width: 8%;
		padding: 0 10px;
	}
    .table_operation {
        padding: 0 10px;
    }
    .table_operation > span {
        margin-right: 10px;
        cursor: pointer;
    }
    .table_operation > span > span {
        margin-right: 2px;
        padding-bottom: 2px;
        border-bottom: 1px solid;
    }
/* 分页 */
    .table_pagination {
        display: flex;
        margin: 20px;
        justify-content: flex-end;
    }
    .annotation {
        font-size: 11px;
        color: #777;
    }
    .annotation > p {
        line-height: 17px;
        margin-left: 18px;
    }
    .annotation .annotation_p {
        margin: 0px;
        margin-top: 10px;
    }
    .annotation .annotation_span {
        border-bottom: 1px solid #326ede;
        color: #326ede;
    }
	
</style>
